var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"custom-loading-mask",attrs:{"id":"loading"}},[_c('svg',{staticClass:"custom-spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }